export const normalizeEmail = (email: string | null | undefined): string => {
	if (!email) return ''
	return email.trim().toLowerCase()
}
